jQuery(function () {
    if($(".dynamic-topic-link").length){
        $('.dynamic-topic-link .categories-content i').click(function (e) {
            var $this = $(this);
            var $thisDce = $this.parent().parent();

            if($this.data('ctaToShow')){
                var buttonToShow = $this.data('ctaToShow');
                // remove quotes from string
                buttonToShow = buttonToShow.replace(/"|'/g, '');

                $thisDce.find("a.brandenbutton").each(function(){
                    if($(this).data('ctaId') == buttonToShow){
                        $(this).fadeIn();
                    }
                    else{
                        $(this).hide();
                    }
                });
            }
        });
    }
});